import { useGetApprovalItem } from 'api-hooks/approval-item';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ApprovalItemForm from './components/form';

export type ApprovalItemViewParams = {
  id: string;
  title?: string;
};

export default function ApprovalItemView(
  props: NavigationProps<NavigationRoutes.ApprovalItemsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetApprovalItem({
    id,
  });

  const approval = data?.data;
  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {approval && (
            <ApprovalItemForm
              approval={approval}
              customViewName={props.navigation.params?.title}
            />
          )}
        </>
      }
    />
  );
}
